import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716131cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Detalhes do Item de Análise", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Código: ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Nome: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tipo de Unidade: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Grupo: ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Expressão: ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Tipo: ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Opções de seleção: ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Status: ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Criado em: ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Atualizado em: ")

import { ref } from 'vue';
import { AnalysisItem, AnalysisItemTypeString } from '@/models/analysis-item';

interface Props {
  analysisItem: AnalysisItem | null;
}

interface Emits {
  (e: 'open'): void;
  (e: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    analysisItem: null
  },
  emits: ["open", "close"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'open'): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {




const show = ref<boolean>(false);

const open = () => {
  show.value = true;
  emit('open');
};

const close = () => {
  show.value = false;
  emit('close');
};

expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "view-modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.id), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.text), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.unit), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.group), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.expression), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(AnalysisItemTypeString)[__props.analysisItem!.type]), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.selectOptions), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.hidden ? 'Desativado' : 'Ativado'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.createdAt.format('L')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.analysisItem?.updatedAt?.format('L') || '-'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Fechar",
                onClick: close
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})